import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type VariantSelectorItemClasses =
  | 'summary'
  | 'root'
  | 'selected'
  | 'expandIcon'
  | 'accordionSummaryContent'
  | 'fullNameText'
  | 'modelNameText';

// Used to increase specificity
const PAPER_ROOT = '&$root';
const SUMMARY_ROOT = '&$summary';

const variantSelectorItemStyles = makeStyles<ISpcTheme, VariantSelectorItemClasses>(
  theme => ({
    root: {
      [PAPER_ROOT]: {
        padding: '4px 16px 4px 16px',
        width: '100%',
        display: 'block',
        marginTop: 12,
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.primaryDisabled.main}`,
        borderRadius: 0,
        textAlign: 'left',
        marginBottom: 16,
        transition: theme.transitions.create(['box-shadow']),
        '&:first-child': {
          marginTop: 12,
        },
        '&:hover': {
          boxShadow: `0px 0px 8px -2px rgba(0,0,0,0.45)`,
        },
      },
    },
    summary: {
      [SUMMARY_ROOT]: {
        minHeight: 'initial',
      },
      paddingTop: 0,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
    },
    selected: {
      [PAPER_ROOT]: {
        borderColor: theme.palette.primary.light,
      },
    },
    expandIcon: {
      padding: 4,
    },
    accordionSummaryContent: {
      position: 'relative',
      top: -5,
    },
    fullNameText: {},
    modelNameText: {},
  }),
  { name: 'Customise_VariantSelectorItem' },
);

export default variantSelectorItemStyles;
